import { host } from 'config';

export const uploadPath = path => `${host}/upload/default/${path}`;
export const uploadStaticPath = path => `${host}/upload/static/${path}`;
export const apiPath = path => `${host}/api/${path}`;
export const exportPath = path => `${host}/api/exports/${path}`;
